<template>
    <v-card
            elevation="10"
            :loading="isLoading"
    >
        <v-card-title>{{ cardData.header }}</v-card-title>
        <v-container>
            <v-row align="start"
                   justify="start"
                   dense
            >
                <v-col
                        v-for="(data_row, index) in cardData.data_rows"
                        :key="data_row.pk"
                        :cols="12"
                        :lg="3"
                        :md="4"
                        :sm="6"
                >
                    <v-card :color="data_row.is_sum_row ? '#F7F7F7' : ''">
                        <v-card-title>
                            {{ data_row.main_header }}
                        </v-card-title>
                        <v-card-text>
                            <h1>{{ formatValue(data_row.main_value) }} {{ data_row.main_value_unit }}</h1>
                            <div class="mt-3"
                                 v-if="data_row.sub_value && index !== 0"
                            >
                                {{ formatValue(data_row.sub_value) }} {{ data_row.sub_value_unit }} {{
                                data_row.sub_header }}
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
            <v-divider></v-divider>
        </v-container>
    </v-card>
</template>
<script lang="ts">
    import FormatHelper from "../core/helpers/format-helper";
    export default {
        name: 'statistic-card',
        props: {
            cardData: {},
            isLoading: Boolean,
        },
        methods: {
            formatValue(value_to_format) {
                return FormatHelper.formatValueWithNoDecimals(value_to_format);
            }
        }
    }
</script>